var angular = require('angular');
var _module = require('./index');

require('./counterpart-info');
require('angularyoutube');

_module.requires.push(
    'youtube-embed'
);

_module.directive('aboutSlide', [function () {
    return {
        restrict: 'E',
        templateUrl: 'js/components/modals/templates/about-slide.tmpl.html',
        scope: {
            counterpart: '=',
            report: '=',
            isMobile: '='
        },
        bindToController: true,
        controllerAs: 'vm',
        controller: [
            '$scope',
            function($scope) {
                var vm = this;
                vm.model = {
                    description: null
                };

                $scope.$watch('vm.counterpart', function() {
                    setDescription();
                });

                init();

                function init() {
                    setDescription();
                }

                function setDescription() {
                    vm.model.description = vm.counterpart.description ? vm.counterpart.description : vm.counterpart.bio;
                }
            }
        ]
    };
}]);
